import React, { FC, useEffect, useState } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import SweetTable from "../../../components/SweetTable";
import { DataType } from "ka-table";
import { KATableHeaderTypes } from "../../../components/SweetTable/SweetTable.interface";

import AddScrtinySection from "../scrutiny/AddScrtinySection";
import ScrutinyDetails from "./ScrutinyDetails";
import { IconButton } from "@mui/material";
import PageLoader from "../../../components/Loader/PageLoader";
import useUserStore from "../../../stores/useUserStores";
import useScrutinyServices from "../../../context/useScrutinyServices";
import {
  base64ToString,
  decryptAES256CBC2,
  encryptWithFixedKey,
  generateRandomBytes
} from "../../../utils";
import { ObjectionHandlerTypesWrapper } from "../../../types/onlineExam.interface";
import { motion } from "framer-motion";
import { Search, X } from "lucide-react";

const MobileCardView = ({
  data,
  columns,
  customeComponent,
  setSelectedScrutiny
}: {
  data: any[];
  columns: KATableHeaderTypes[];
  customeComponent: any;
  setSelectedScrutiny: (data: any) => void;
}) => {
  return (
    <div className="grid gap-5 sm:hidden px-2 py-3">
      {!!data &&
        Array.isArray(data) &&
        data.map((item, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden"
          >
            <div className="p-5 space-y-4">
              {columns.map((column) => {
                // Use custom component if defined for this column
                if (column.dataType === "custome") {
                  const customProps = {
                    column,
                    rowData: item,
                    setSelectedScrutiny
                  };
                  const customElement = customeComponent(customProps);
                  if (customElement) {
                    return (
                      <div key={column.key} className="flex flex-col space-y-1">
                        <div className="text-[13px] font-semibold text-gray-600">
                          {column.title}
                        </div>
                        <div className="text-sm min-h-[20px]">
                          {customElement}
                        </div>
                      </div>
                    );
                  }
                }
                // Default rendering for non-custom columns
                return (
                  <div key={column.key} className="flex flex-col space-y-1">
                    <div className="text-[13px] font-semibold text-gray-600">
                      {column.title}
                    </div>
                    <div className="text-sm text-gray-800 break-words">
                      {item[column.key] || "-"}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
    </div>
  );
};

type ExamsScrutinySectionProps = {};
const ExamsScrutinySection: FC<ExamsScrutinySectionProps> = (): JSX.Element => {
  const [searchScriny, setSearchScrutiny] = useState<string>("");
  const [SelectedScrutiny, setSelectedScrutiny] = useState<any>(null);
  const [searchText,setSearchText] = useState<string>("")
    const [activeTab, setActiveTab] = useState<"PENDING" | "REJECTED" | "APPROVED">("PENDING");
  const [openAddScrutinySection, setOpenAddScrutinySection] =
    useState<boolean>(false);
  const [scrutinyList, setScrutinyList] = useState<ObjectionHandlerTypesWrapper | null>(null);
  const userDetails = useUserStore();
  const [loadingAPI, setLoadingAPI] = useState<boolean>(false);
  const scrutinyContext = useScrutinyServices();
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(100);
  const customeComponent = (props: any) => {
    switch (props?.column?.key) {
      case "remarks":
        return (
          <div
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              wordBreak: "break-word"
            }}
            className="flex flex-wrap text-wrap  "
          >
            {props.rowData?.["remarks"]}
          </div>
        );
      case "accept_flag":
        return (
          <div
            className={`font-semibold ${
              props.rowData["accept_flag"] === null
                ? `text-yellow-500`
                : props.rowData["accept_flag"]
                ? `text-emerald-500`
                : `text-red-500`
            }`}
          >
            {props.rowData["accept_flag"] === null
              ? `Pending`
              : props.rowData["accept_flag"]
              ? `Accepted`
              : `Rejected`}
          </div>
        );
      case "question":
        return (
          <div>
            {props.rowData?.["question"] &&
            props.rowData?.["question"]?.trim()?.length ? (
              <div
                style={{
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  wordBreak: "break-word"
                }}
              >
                {props.rowData?.["question"]}
              </div>
            ) : props.rowData?.["question_img"] ? (
              <div>
                <img
                  src={`data:image/png;base64,${props.rowData?.["question_img"]}`}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        );
      case "correct_answer":
        return (
          <div className="text-emerald-500 font-semibold">
            {props.rowData["correct_answer"]}
          </div>
        );
      case "selected_answer":
        return (
          <div className="text-red-500 font-semibold">
            {props.rowData["selected_answer"]}
          </div>
        );
      case "question_id":
        return (
          <div className="">
            <IconButton onClick={() => setSelectedScrutiny(props.rowData)}>
              <RemoveRedEyeIcon className="text-blue-500" />
            </IconButton>
          </div>
        );
    }
  };

  const columns: KATableHeaderTypes[] = [
    {
      key: "id",
      title: "Requestor ID",
      dataType: DataType.String,
      BodytextAlign: "left",
      HeadertextAlign: "left"
    },
    {
      key: "exam_group",
      title: "Exam Name",
      dataType: DataType.String,
      BodytextAlign: "left",
      HeadertextAlign: "left"
    },
    {
      key: "exam_paper",
      title: "Exam Paper Name",
      dataType: DataType.String,
      BodytextAlign: "left",
      HeadertextAlign: "left"
    },
    {
      key: "question",
      title: "Question",
      dataType: "custome",
      BodytextAlign: "left",
      HeadertextAlign: "left",
      width: 400
    },

    {
      key: "marks",
      title: "Alloted Marks",
      dataType: DataType.String,
      BodytextAlign: "left",
      HeadertextAlign: "left"
    },
    {
      key: "accept_flag",
      title: "Status",
      dataType: "custome",
      BodytextAlign: "left",
      HeadertextAlign: "left"
    },
    {
      key: "remarks",
      title: "Candidate Remarks",
      dataType: "custome",
      BodytextAlign: "left",
      HeadertextAlign: "left"
    },
    {
      key: "question_id",
      title: "Actions",
      dataType: "custome",
      BodytextAlign: "left",
      HeadertextAlign: "left"
    }
  ];

  useEffect(() => {
    (async () => {
      setScrutinyList(null)
      setLoadingAPI(true);
      if (userDetails?.userdetail) {
        const encryption_key = generateRandomBytes();

        let rawPayload = {
          email: userDetails?.userdetail?.email,
          user_id: userDetails?.userdetail?.id,
          page_index:page,
          page_size:rowsPerPage,
          accepted:activeTab==="PENDING" ? null : activeTab ==="APPROVED" ? true:false,
          search_string:searchText,
          encryption_key
        };

        console.log("rawPayload >>>> ",rawPayload);
        

        const payload = encryptWithFixedKey(rawPayload);
        const response = await scrutinyContext.getScrutinyList({
          payload
        });

  

        if (response && response?.response) {
          const rawResponse = await decryptAES256CBC2(
            response?.response,
            btoa(encryption_key)
          );
          const responsedData = JSON.parse(rawResponse);
          console.log("responsedData >>>> ",responsedData);
          
          setScrutinyList(responsedData);
    
        }

        // setScrutinyList(response);
      }
    })();
    setLoadingAPI(false);
  }, [page,rowsPerPage,activeTab]);

    const statusTabs = [
  {
    id: "PENDING",
    label: "Pending Objection",
    color: "text-amber-600",
    bgColor: "bg-amber-50",
    borderColor: "border-amber-200",
    activeColor: "bg-amber-100",
    icon: "⏳",
  },
  {
    id: "APPROVED",
    label: "Approved Objection", 
    color: "text-emerald-600",
    bgColor: "bg-emerald-50",
    borderColor: "border-emerald-200",
    activeColor: "bg-emerald-100",
    icon: "✅",
  },
  {
    id: "REJECTED",
    label: "Rejected Objection",
    color: "text-rose-600", 
    bgColor: "bg-rose-50",
    borderColor: "border-rose-200",
    activeColor: "bg-rose-100",
    icon: "❌",
  },
];

  
  
  const refreshList = async (_searchText?:string) => {
    if (userDetails?.userdetail) {
      const encryption_key = generateRandomBytes();

      let rawPayload = {
        email: userDetails?.userdetail?.email,
        user_id: userDetails?.userdetail?.id,
           page_size: rowsPerPage,
              search_string: _searchText !==undefined ? _searchText : searchText,
              page_index: page,
              encryption_key,
              accepted:activeTab==="PENDING" ? null : activeTab ==="APPROVED" ? true:false
      };

      const payload = encryptWithFixedKey(rawPayload);
      const response = await scrutinyContext.getScrutinyList({
        payload
      });

      if (response && response?.response) {
        const rawResponse = await decryptAES256CBC2(
          response?.response,
          btoa(encryption_key)
        );
        const responsedData = JSON.parse(rawResponse);
        setScrutinyList(responsedData);
      }
    }
    setOpenAddScrutinySection(false);
  };


  console.log("SelectedScrutiny >>>> ",SelectedScrutiny);
  
  if (loadingAPI) return <PageLoader loading />;
  return (
    <div className="mx-3 mt-5 mb-6  min-h-[85vh] ">
      <ScrutinyDetails
        selectedScrutiny={SelectedScrutiny}
        handleClose={() => setSelectedScrutiny(null)}
      />
      <AddScrtinySection
        openModal={openAddScrutinySection}
        handleCloseModal={() => setOpenAddScrutinySection(false)}
        refreshList={refreshList}
      />
      <div className="flex flex-col lg:flex-row justify-between lg:items-center mb-1 bg-gray-100 px-5 py-3 rounded-t-lg">
        <h2 className="text-xl font-bold text-gray-700">
          Objection Management
        </h2>
        {/* <button
          className="bg-[#094780] px-6 py-2 mt-3 lg:mt-0 text-white font-semibold rounded-md"
          onClick={() => setOpenAddScrutinySection(true)}
        >
          Raise Objection
        </button> */}
      </div>
      <div className="mt-2">
        {/* Mobile/Tablet Card View (hidden on desktop) */}
        <div className="sm:hidden">
          <MobileCardView
            data={scrutinyList && scrutinyList?.data ? scrutinyList.data : []}
            columns={columns}
            customeComponent={customeComponent}
            setSelectedScrutiny={setSelectedScrutiny}
          />
        </div>

        <div className="flex space-x-1 p-1 bg-gray-50 rounded-xl shadow-sm border border-gray-200">
          {statusTabs.map((tab) => {
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() =>
                  setActiveTab(tab.id as "PENDING" | "REJECTED" | "APPROVED")
                }
                className={`
                        relative flex items-center justify-center px-6 py-3 rounded-lg text-sm font-medium
                        transition-all duration-200 ease-in-out transform hover:scale-[1.02]
                        ${
                          isActive
                            ? `${tab.activeColor} ${tab.color} shadow-md ring-1 ${tab.borderColor}`
                            : "text-gray-600 hover:text-gray-900 hover:bg-white"
                        }
                      `}
              >
                <span className="mr-2 text-lg">{tab.icon}</span>
                <span className="font-semibold">{tab.label}</span>
                {/* Active indicator */}
                {/* {isActive && (
                        <div className={`
                          absolute -bottom-1 left-1/2 transform -translate-x-1/2
                          w-12 h-1 ${tab.color.replace('text-', 'bg-')} rounded-full
                        `} />
                      )} */}
              </button>
            );
          })}
        </div>
        <div className="w-full  mt-1  ">
          <div className="grid grid-cols-12 gap-y-2 gap-x-4  w-[99.5%] ">
            <div className="col-span-12   mt-4  ">
              <div className="relative mb-6 flex items-center">
                <motion.div
                  className="absolute left-3 top-1/4 transform -translate-y-1/2"
                  animate={{ scale: [1, 1.1, 1] }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }}
                >
                  <Search className="h-5 w-5 text-gray-400" />
                </motion.div>
                {searchText?.trim()?.length ? (
                  <motion.div
                    className="absolute right-[12%] top-1/4 transform -translate-y-1/2  !z-[600] cursor-pointer"
                    onClick={() => {
                      refreshList("");
                      setSearchText("");
                    }}
                    animate={{ scale: [1, 1.1, 1] }}
                    transition={{
                      duration: 2,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                  >
                    <X className="h-5 w-5 text-gray-700" />
                  </motion.div>
                ) : (
                  <></>
                )}

                <motion.input
                  type="text"
                  placeholder="Search Request .."
                  value={searchText}
                  onChange={(e: any) => setSearchText(e.target.value)}
                  // onFocus={() => setIsFocused(true)}
                  // onBlur={() => setTimeout(() => setIsFocused(false), 200)}
                  className="w-full pl-10 pr-4 py-3 bg-white/90 border border-gray-200 rounded-l-lg outline-none transition-all duration-200"
                  whileFocus={{ scale: 1.01 }}
                />
                <motion.button
                  disabled={searchText?.trim()?.length === 0}
                  onClick={() => {
                    refreshList(searchText?.trim());
                  }}
                  className={`bg-blue-500 hover:bg-blue-700 cursor-pointer text-white px-5 py-[13px] ${
                    searchText?.trim()?.length === 0
                      ? "!cursor-not-allowed"
                      : "cursor-pointer"
                  }`}
                >
                  Search
                </motion.button>
              </div>
            </div>
          </div>
        </div>

        {/* Desktop Table View (hidden on mobile) */}
        <div className="hidden sm:block" key={activeTab}>
          <SweetTable
            tableColumns={columns || []}
            tableData={
              scrutinyList && scrutinyList?.data ? scrutinyList.data : []
            }
            // pageCount={scrutinyList  && scrutinyList?.total_count ? scrutinyList.total_count:0}
            pageCount={
              scrutinyList && scrutinyList?.total_count
                ? Math.ceil(+scrutinyList?.total_count / rowsPerPage)
                : 0
            }
            setPageIndex={setPage}
            CustomePageSizes={[100, 200, 300, 400, 500]}
            pageIndex={page}
            setPageSize={setRowsPerPage}
            pageSize={rowsPerPage}
            actionBtnsReq={false}
            isSSR
            filtersAllow={false}
            ColumnSettings={true}
            customeComponent={customeComponent}
          />
        </div>
      </div>
    </div>
  );
};

export default ExamsScrutinySection;
